import { Component, input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { toLocaleISOString } from '@softline/core';
import { FieldValidationDirective, IconComponent, InputComponent, MultilineInputComponent, ResolvableModal, Validators } from '@softline/ui-core';
import { DateInputComponent } from '@softline/ui-core/date-input';
import { TimeInputComponent } from '@softline/ui-core/date-input';
import { setTimeOfDate } from '../../functions/set-time-of-date.function';
import { Task } from '../../types/pms-task';
import { RosterContent } from '../../types/roster-content';

@Component({
  selector: 'soft-roster-content-create',
  imports: [
    ReactiveFormsModule,
    FieldValidationDirective,
    DateInputComponent,
    TimeInputComponent,
    InputComponent,
    MultilineInputComponent,
    IconComponent,
  ],
  templateUrl: './roster-content-create.component.html',
  styleUrl: './roster-content-create.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [],
})
export class RosterContentCreateComponent
  extends ResolvableModal<null>
  implements OnInit
{
  readonly date = input.required<string>();
  readonly resource = input.required<number>();
  readonly onSave = input.required<(_: Partial<RosterContent>) => Promise<void>>();

  readonly form = new FormGroup({
    taskLabel: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required(), Validators.min(3)],
    }),
    beginTime: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required()],
    }),
    beginDay: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required()],
    }),
    endDay: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required()],
    }),
    endTime: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required()],
    }),
    comment: new FormControl<string | null>(null),
    status: new FormControl<string>('U', {
      nonNullable: true,
      validators: [Validators.required()],
    }),
    type: new FormControl<string>('PLAN', {
      nonNullable: true,
      validators: [Validators.required()],
    }),
  });

  ngOnInit() {
    const data = this.date();
    this.form.patchValue({
      taskLabel: 'Neue Tätigkeit',
      // beginTime: `T${(data ?? '').split('T')[1]}`,
      beginTime: 'T08:00:00',
      beginDay: data,
      endDay: data,
      // endTime: `T${(data ?? '').split('T')[1]}`,
      endTime: 'T17:00:00',
    });
  }

  async onSubmit(): Promise<void> {
    if (!this.form.valid) return;

    const formValue = this.form.getRawValue();

    console.log('formValue: ', formValue);

    const startDate = setTimeOfDate(formValue.beginDay, formValue.beginTime);
    const endDate = setTimeOfDate(formValue.endDay, formValue.endTime);

    if (!startDate || !endDate) return;

    const start = toLocaleISOString(startDate);
    const end = toLocaleISOString(endDate);

    const body = [
      {
        resource: [this.resource()],
        start: start,
        end: end,
        title: formValue.taskLabel,
        additionalData: {
          employees: [],
          begintime: start,
          endtime: end,
          type: formValue.type,
          status: formValue.status,
          comment: formValue.comment,
          task: {
            name: formValue.taskLabel,
          } as Task,
          department: {},
          additionaldetail: [],
        },
      },
    ] as Partial<RosterContent>;

    console.log('create: ', body);
    await this.onSave()(body);
    this.resolve(null);
  }
}
